import { render, staticRenderFns } from "./TableGridSizeEditor.vue?vue&type=template&id=3f99b3f6&"
import script from "./TableGridSizeEditor.vue?vue&type=script&lang=js&"
export * from "./TableGridSizeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports